import styled from 'styled-components';


export const ActivityContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 24px 12px;
  justify-content: space-between;
  border-bottom: 0.5px solid ${({ theme }) => theme?.colors?.text?.muted};
  box-shadow: 0px 5px 32px 0px rgba(0, 67, 101, 0.08);
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const ImageWrapper = styled.div`
  width: 32px;
  height: 32px;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 8px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;  // This maintains aspect ratio and covers the container
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;

  h3 {
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5;
    margin: 0;
  }

  span {
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Red Hat Display", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }
`;

export const BalanceText = styled.div<{ $isNegative?: boolean }>`
    color: ${({ $isNegative, theme }) => $isNegative ? theme?.colors?.theme?.brandColor3 : theme?.colors?.common?.green};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
`;